<template>
    <div class="image-video-compression-system">
        <Row>
            <Col>
                <div class="core-title">产品概述</div>
            </Col>
        </Row>
        <Row type="flex" justify="space-around" align="middle">
            <Col span="10">
                <div class="core-text">
                    <p>
                        目前互联网90%以上的图片格式是JPEG，而TIFF格式是医院、地理遥感、水利等领域80%以上的通用格式。本系统可实现在不改变画质、不改变格式的情况下，JPEG图片压缩到原来的1/2至1/4，TIFF图片压缩到原来的1/4至1/10。一张JPEG图片压缩平均小于100毫秒。本产品可以极大地节约图片物理存储空间，降低图片传输所需带宽。
                    </p>
                    <p>
                        随着监控摄像头越来越高清，存储周期越来越长，存储硬盘空间也呈指数型增长。不仅给用户带来物理空间的扩张，也无法适应现代社会绿色节能的理念。本系统可以在不改变画质的情况下，1080p高清视频可以压缩到原来的1/8，720p可以压缩到原来的1/6到1/7，极大减少物理存储空间，节约能源。
                    </p>
                </div>
            </Col>
            <Col span="8">
                <div class="core-img">
                    <img src="@/images/core/imageVideo.jpg" alt="高倍率图像/视频无损压缩系统">
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">行业分析</div>
            </Col>
        </Row>
        <Row>
            <Col>
                <Row class="core-content">
                    <Col span="11">
                        <div class="core-weakness core-weakness-left">
                            <div class="text">
                                <h5 class="text-right">兼容性能低</h5>
                                <p>市场普遍的压缩技术不具备较强兼容性，无论是硬件兼容还是软件系统兼容，都存在很大的问题，压缩格式相对较少，压缩市场有局限性。</p>
                            </div>
                            <div class="img">
                                <img src="@/images/core/imageVideoWeakness1.png" alt="高倍率图像/视频无损压缩系统">
                            </div>
                        </div>
                    </Col>
                    <Col span="11" offset="2">
                        <div class="core-weakness core-weakness-right">
                            <div class="img">
                                <img src="@/images/core/imageVideoWeakness2.png" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="text">
                                <h5>压缩比率低</h5>
                                <p>国内压缩技术，以主流格式而言压缩比率一般都在3倍左右，且几年时间都没有突破这个瓶颈，压缩技术发展得不到长远的提高。</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row class="core-content">
                    <Col span="11">
                        <div class="core-weakness core-weakness-left">
                            <div class="text">
                                <h5 class="text-right">成本费用高</h5>
                                <p>目前而言，国内压缩技术分很多种类，市场需求技术得不到统一，造成压缩市场混乱，用户经济流失，从而成本费用增高，产生成本浪费。</p>
                            </div>
                            <div class="img">
                                <img src="@/images/core/imageVideoWeakness3.png" alt="高倍率图像/视频无损压缩系统">
                            </div>
                        </div>
                    </Col>
                    <Col span="11" offset="2">
                        <div class="core-weakness core-weakness-right">
                            <div class="img">
                                <img src="@/images/core/imageVideoWeakness4.png" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="text">
                                <h5>技术相对于落后</h5>
                                <p>压缩技术的普遍运用是近几年才被广泛兴起，国内压缩技术还没有遇到市场的抨击，以至于压缩市场一直稳步不前，压缩技术停滞，相对于国际而言技术落后。</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">功能简介</div>
            </Col>
        </Row>
        <Row type="flex" justify="center" align="middle">
            <Col span="5">
                <div class="core-card">
                    <div class="core-card-title">
                        <img src="@/images/core/img.png" alt="高倍率图像/视频无损压缩系统">
                        <span>图片压缩</span>
                    </div>
                    <ul>
                        <li>支持JPEG/TIFF/BMP/GIF/PNG等主流格式</li>
                        <li>智能选择压缩比率和图像格式</li>
                        <li>压缩前后视觉无损，效果保持一致</li>
                        <li>创新自动压缩程序，实现无人监管任务</li>
                    </ul>
                </div>
            </Col>
            <Col span="3">
                <img src="@/images/core/rightLine.png" alt="高倍率图像/视频无损压缩系统">
            </Col>
            <Col span="14">
                <div class="core-img">
                    <img src="@/images/core/imageVideoSystem.png" alt="高倍率图像/视频无损压缩系统">
                </div>
            </Col>
        </Row>
        <Row type="flex" justify="center" align="middle" style="margin-top: 20px">
            <Col span="15">
                <div class="core-img">
                    <img src="@/images/core/imageVideoSystem2.png" alt="高倍率图像/视频无损压缩系统">
                </div>
            </Col>
            <Col span="5">
                <div class="core-card">
                    <div class="core-card-title">
                        <img src="@/images/core/video.png" alt="高倍率图像/视频无损压缩系统">
                        <span>视频压缩</span>
                    </div>
                    <ul>
                        <li>支持H.264和H.265编码，支持RTSP等网络协议</li>
                        <li>支持软件集成的开放式API，支持标准ONVIF协议</li>
                        <li>压缩前后视觉无损，效果保持一致</li>
                    </ul>
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">应用领域</div>
            </Col>
        </Row>
        <Row class="core-applications core-content">
            <Col style="width: 100%">
                <Row type="flex" justify="space-around">
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-library.jpg" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>图书档案<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-anfang.jpg" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>安防监控<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-yixue.png" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>医学成像<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-dili.jpg" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>地理信息<span>--</span></div>
                        </div>
                    </Col>
                </Row>
                <Row type="flex" justify="space-around">
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-yaogan.jpg" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>遥感影像<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-kuang.jpg" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>矿产勘探<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-guofang.jpg" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>国防军事<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-jianzhu.jpg" alt="高倍率图像/视频无损压缩系统">
                            </div>
                            <div class="title"><span>--</span>建筑设计<span>--</span></div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
  name: 'non-perceptual-security-system'
};
</script>

<style lang="less">
    .image-video-compression-system {
        .core-img {
            height: 375px;
        }
    }
</style>
